export default class BottleSize {
	constructor() {
		this.id = null;
		this.title = null;
		this.amount = null;
	}
}